import uuid from 'uuid';
import { type IssueId, type IssueKey, toIssueId } from '@atlassian/jira-shared-types';
import type { ProjectId } from './app';
import type { Creatable, Modifiable } from './common';
import type { IssueTypeId } from './issue-type';

// eslint-disable-next-line jira/export/no-external-exports
export { toIssueKey, toIssueIdArray } from '@atlassian/jira-shared-types';
// eslint-disable-next-line jira/export/no-external-exports
export { toIssueId };
// eslint-disable-next-line jira/export/no-external-exports
export type { IssueId, IssueKey };

export const newRandomIssueId = (): IssueId => toIssueId(uuid.v4());

type AnalyticsUpdatedItem = {
	name: string;
};

export type AnalyticsUpdatedItems = AnalyticsUpdatedItem[];

export type CommonIssue<TAdditionalFields> = Creatable & {
	key: IssueKey | undefined;
	summary: Modifiable<string>;
	projectId: ProjectId;
	issueTypeId: IssueTypeId;
} & TAdditionalFields;
